import { createApi } from '@reduxjs/toolkit/query/react';

import { CMSStandardItem } from '@/slices/cms/standards/cmsStandards.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

export interface StandardsResponse {
  standards?: Array<CMSStandardItem>;
}

const cmsStandardsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms',
  }),
  reducerPath: 'cmsStandards',
  tagTypes: ['CmsStandards'],
  endpoints: (build) => ({
    getStandards: build.query<CMSStandardItem[], void>({
      query: () => ({
        url: '/standards',
        method: 'GET',
      }),
      transformResponse: (response: StandardsResponse) =>
        response.standards ?? [],
    }),
  }),
});

export default cmsStandardsApi;
